import React from 'react';
import './AppealDescription.scss';

interface AppealDescriptionProps {
  setDescription: (description: string) => void;
  label?: string;
  data: string;
  maxLength?: number;
}

const AppealDescription = (props: AppealDescriptionProps): JSX.Element => {
  return (
    <div className="appealDescription">
      <label>{props.label ? props.label : 'Текст сообщения'}</label>
      <textarea
        onChange={(event) => {
          props.setDescription(event.target.value);
        }}
        onBlur={(event) => {
          props.setDescription(event.target.value);
        }}
        value={props.data}
        maxLength={props.maxLength ? props.maxLength : 1000}
      />
    </div>
  );
};

export default AppealDescription;
